import type { SummaryDataField } from '../types';

export const isMoneyType = (field: SummaryDataField) => {
  return field === 'loansAmount' || field === 'salesAmount';
};
